{
  "Clear search": "Vymazať vyhľadávanie"
}
